import React from 'react';
import Collapse from 'react-bootstrap/lib/Collapse';
import { SelectInput } from 'components/forms';

export default class extends React.Component {
    static propTypes = {
        name: React.PropTypes.string.isRequired,
        open: React.PropTypes.bool.isRequired,
        onToggle: React.PropTypes.func.isRequired,
        onChange: React.PropTypes.func.isRequired,
        value: React.PropTypes.string,
    };

    onToggle = () => {
        this.props.onToggle(this.props.name);
    };

    onChange = ({ value }) => {
        this.props.onChange(this.props.name, value);
    };

    render() {
        return (
            <div className="search-filter">
                <div className="search-filter__header">
                    <span className="search-filter__title">Catering</span>
                    {this.props.open && <span className="search-filter__toggle search-filter__toggle--opened" onClick={this.onToggle}>X</span>}
                    {!this.props.open && <span className="search-filter__toggle search-filter__toggle--closed" onClick={this.onToggle}>+</span>}
                </div>

                <Collapse in={this.props.open}>
                    <div className="search-filter__filter">
                        <SelectInput
                            value={this.props.value}
                            onChange={this.onChange}
                            options={[{
                                value: 'In-House/Preferred Catering Required',
                                label: 'In-House/Preferred Catering Required',
                            }, {
                                value: 'In-House/Preferred Catering Optional',
                                label: 'In-House/Preferred Catering Optional',
                            }, {
                                value: 'External Catering Only',
                                label: 'External Catering Only',
                            }]}
                        />
                    </div>
                </Collapse>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/VenueSearch/CateringRequirementFilter.jsx